import PropTypes from 'prop-types';

import Colors from '../utils/colors';

const FileUploadDone = ({ className = '' }) => (
  <svg width="24" height="24" className={className}>
    <g fill="none" fillRule="evenodd" stroke={Colors.success}>
      <path fill="white" d="M.5.5v22h16V4.207L12.793.5H.5z" />
      <path d="M12.5 0v4.5H17" />
    </g>
  </svg>
);

FileUploadDone.propTypes = {
  className: PropTypes.string
};

export default FileUploadDone;
